const QuickResponseIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.666 3.029a.5.5 0 0 1 .332.516l-.45 4.955H17.5a.5.5 0 0 1 .403.796l-5.5 7.5a.5.5 0 0 1-.895-.385l.893-4.911H8.5a.5.5 0 0 1-.416-.777l5-7.5a.5.5 0 0 1 .582-.194M9.434 10.5H13a.5.5 0 0 1 .492.59l-.612 3.364L16.513 9.5H13a.5.5 0 0 1-.498-.545l.322-3.54zM3.5 6a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1H4a.5.5 0 0 1-.5-.5M2 10a.5.5 0 0 1 .5-.5H6a.5.5 0 1 1 0 1H2.5A.5.5 0 0 1 2 10m1.5 4a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5"
      fill="currentColor"
    />
  </svg>
);
export default QuickResponseIcon;
